import { render, staticRenderFns } from "./EditCategoryList.vue?vue&type=template&id=040dd914"
import script from "./EditCategoryList.vue?vue&type=script&lang=js"
export * from "./EditCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports